import { service } from '../index.js';

const resource = process.env.VUE_APP_RESOURCE_SICUD_DEPLOY_MF;

export default {
  get(payload) {
    return service.post(resource, payload);
  },
};
